import {ISearchFiltersFormValues} from "../../../search/types/ISearchFiltersFormValues";
import {ILatestQuery} from "../../../utils/latest_query";
import {getOrCreateOfferListingAmplitudeItemListId} from "../../list/helpers/offer_listing_amplitude_item_list_id";
import {IOfferListLatestQuery} from "../../list/types/IOfferListLatestQuery";
import {
    floorChoiceOptions,
    houseAdditionalAreasOptions,
    houseStoreysOptions,
    houseTypeOptions,
    mapArea,
    mapBudget,
    mapCompletionDate,
    mapFromFilterOptions,
    mapPropertyType,
    mapRooms
} from "./amplitude_listing_filters_tracking_utils";

export interface IGetAmplitudeListingFiltersAppliedParams {
    formValues: ISearchFiltersFormValues;
    latestQuery: ILatestQuery;
}

export const getAmplitudeListingFiltersAppliedEventProperties = ({formValues, latestQuery}: IGetAmplitudeListingFiltersAppliedParams) => {
    const property_type = mapPropertyType(formValues.type);
    const budget = mapBudget(formValues.price, formValues.instalment);
    const rooms = mapRooms(formValues.rooms);
    const area = mapArea(formValues.area);
    const floor = mapFromFilterOptions(formValues.floor_choices, floorChoiceOptions);
    const completion_date = mapCompletionDate(formValues.construction_end_date);
    const house_type = mapFromFilterOptions(formValues.house_type, houseTypeOptions);
    const house_additional_areas = mapFromFilterOptions(formValues.house_additional_areas, houseAdditionalAreasOptions);
    const house_storeys = mapFromFilterOptions(formValues.house_storeys, houseStoreysOptions);
    const item_list_id = getOrCreateOfferListingAmplitudeItemListId(latestQuery as IOfferListLatestQuery);

    return {
        ...(property_type ? {property_type} : {}),
        ...(budget ? {budget} : {}),
        ...(rooms ? {rooms} : {}),
        ...(area ? {area} : {}),
        ...(floor ? {floor} : {}),
        ...(completion_date ? {completion_date} : {}),
        ...(house_type ? {house_type} : {}),
        ...(house_additional_areas ? {house_additional_areas} : {}),
        ...(house_storeys ? {house_storeys} : {}),
        ...(item_list_id ? {item_list_id} : {})
    };
};
import {ISearchFiltersFormValues} from "../../../search/types/ISearchFiltersFormValues";
import {ILatestQuery} from "../../../utils/latest_query";
import {getOrCreateOfferListingAmplitudeItemListId} from "../../list/helpers/offer_listing_amplitude_item_list_id";
import {IOfferListLatestQuery} from "../../list/types/IOfferListLatestQuery";
import {
    floorChoiceOptions,
    houseAdditionalAreasOptions,
    houseStoreysOptions,
    houseTypeOptions,
    mapArea,
    mapBudget,
    mapCompletionDate,
    mapFromFilterOptions,
    mapPropertyType,
    mapRooms
} from "./amplitude_listing_filters_tracking_utils";

export interface IGetAmplitudeListingFiltersAppliedParams {
    formValues: ISearchFiltersFormValues;
    latestQuery: ILatestQuery;
}

export const getAmplitudeListingFiltersAppliedEventProperties = ({formValues, latestQuery}: IGetAmplitudeListingFiltersAppliedParams) => {
    const property_type = mapPropertyType(formValues.type);
    const budget = mapBudget(formValues.price, formValues.instalment);
    const rooms = mapRooms(formValues.rooms);
    const area = mapArea(formValues.area);
    const floor = mapFromFilterOptions(formValues.floor_choices, floorChoiceOptions);
    const completion_date = mapCompletionDate(formValues.construction_end_date);
    const house_type = mapFromFilterOptions(formValues.house_type, houseTypeOptions);
    const house_additional_areas = mapFromFilterOptions(formValues.house_additional_areas, houseAdditionalAreasOptions);
    const house_storeys = mapFromFilterOptions(formValues.house_storeys, houseStoreysOptions);
    const item_list_id = getOrCreateOfferListingAmplitudeItemListId(latestQuery as IOfferListLatestQuery);

    return {
        ...(property_type ? {property_type} : {}),
        ...(budget ? {budget} : {}),
        ...(rooms ? {rooms} : {}),
        ...(area ? {area} : {}),
        ...(floor ? {floor} : {}),
        ...(completion_date ? {completion_date} : {}),
        ...(house_type ? {house_type} : {}),
        ...(house_additional_areas ? {house_additional_areas} : {}),
        ...(house_storeys ? {house_storeys} : {}),
        ...(item_list_id ? {item_list_id} : {})
    };
};
